import constants from '../../../libs/constant/constants'
import pageRoutes from '../../../libs/constant/pageRoutes'
import {errorHandler, message, logout, loader} from '@/libs/helper'
import {
    fetchStripeCustomerId,
    updatePaymentMethod,
    subscribePlan,
    getAllPlans,
    getActiveSubscription,
    updateUserPlan
} from '@/libs/api/api'

export default{
    data(){
        return {
            card: {},
            plans: [],
            selectedPlan: '',
            activePlan: '',
            showPayment: false,
            showSubscription: false,
            globalStripe: {}
    }

    },
    beforeMount(){
        if(this.$route.query.module === 'payment'){
            this.showPayment = true
            this.showSubscription = false
        }else if(this.$route.query.module === 'subscription'){
            this.showPayment = false
            this.showSubscription = true
            this.getPaymentDetails()
        }
        this.getSubscriptionsPlan()
        this.getUserActiveSubscription()
    },
    mounted(){
        let stripeKey = process.env.VUE_APP_STRIPE_PUBLISH_KEY
        // eslint-disable-next-line
        let stripe = Stripe(stripeKey);
        this.globalStripe = stripe

        let elements = stripe.elements({
            fonts: [
                {
                    cssSrc: 'https://fonts.googleapis.com/css?family=Quicksand',
                },
            ],
            // Stripe's examples are localized to specific languages, but if
            // you wish to have Elements automatically detect your user's locale,
            // use `locale: 'auto'` instead.
            locale: window.__exampleLocale,
        });


        let elementStyles = {
            base: {
                color: '#242424',
                fontWeight: 'normal',
                fontSize: '16px',
                fontSmoothing: 'antialiased',

                ':focus': {
                    color: '#424770',
                },

                '::placeholder': {
                    color: '#9BACC8',
                },

                ':focus::placeholder': {
                    color: '#CFD7DF',
                },
            },
            invalid: {
                color: '#fff',
                ':focus': {
                    color: '#FA755A',
                },
                '::placeholder': {
                    color: '#FFCCA5',
                },
            },
        };

        let elementClasses = {
            focus: 'focus',
            empty: 'empty',
            invalid: 'invalid',
        };

        let cardNumber = elements.create('cardNumber', {
            style: elementStyles,
            classes: elementClasses
        });
        cardNumber.mount('#example3-card-number');

        let cardExpiry = elements.create('cardExpiry', {
            style: elementStyles,
            classes: elementClasses,
        });
        cardExpiry.mount('#example3-card-expiry');

        let cardCvc = elements.create('cardCvc', {
            style: elementStyles,
            classes: elementClasses,
        });
        cardCvc.mount('#example3-card-cvc');

        let postalCode = elements.create('postalCode', {
            style: elementStyles,
            classes: elementClasses,
        });
        postalCode.mount('#example3-card-postal-code');

        this.registerElements([cardNumber, cardExpiry, cardCvc, postalCode], 'example3', stripe);
    },
    methods:{
        registerElements(elements, exampleName, stripe){
            let that = this
        let formClass = '.' + exampleName;
        let example = document.querySelector(formClass);

        let form = example.querySelector('form');
        let error = form.querySelector('.error');
        let errorMessage = error.querySelector('.message');
        let button = document.getElementById('button')

        function enableInputs() {
            Array.prototype.forEach.call(
                form.querySelectorAll(
                    "input[type='text'], input[type='email'], input[type='tel']"
                ),
                function(input) {
                    input.removeAttribute('disabled');
                }
            );
        }

        function disableInputs() {
            Array.prototype.forEach.call(
                form.querySelectorAll(
                    "input[type='text'], input[type='email'], input[type='tel']"
                ),
                function(input) {
                    input.setAttribute('disabled', 'true');
                }
            );
        }

            function triggerBrowserValidation(){
            // The only way to trigger HTML5 form validation UI is to fake a user submit
            // event.
            let submit = document.createElement('input');
            submit.type = 'submit';
            submit.style.display = 'none';
            form.appendChild(submit);
            submit.click();
            submit.remove();
        }

        // Listen for errors from each Element, and show error messages in the UI.
        let savedErrors = {};
        elements.forEach(function(element, idx) {
            element.on('change', function(event) {
                if (event.error) {
                    error.classList.add('visible');
                    savedErrors[idx] = event.error.message;
                    errorMessage.innerText = window.i18next.t(event.error.message);
                } else {
                    savedErrors[idx] = null;

                    // Loop over the saved errors and find the first one, if any.
                    let nextError = Object.keys(savedErrors)
                        .sort()
                        .reduce(function(maybeFoundError, key) {
                            return maybeFoundError || savedErrors[key];
                        }, null);

                    if (nextError) {
                        // Now that they've fixed the current error, show another one.
                        errorMessage.innerText = window.i18next.t(nextError);
                    } else {
                        // The user fixed the last error; no more errors.
                        error.classList.remove('visible');
                        errorMessage.innerText = '';
                    }
                }
            });
        });

        // Listen on the form's 'submit' handler...
            button.addEventListener('click', function(e) {
            e.preventDefault();

            // Trigger HTML5 validation UI on the form if any of the inputs fail
            // validation.
            let plainInputsValid = true;
            Array.prototype.forEach.call(form.querySelectorAll('input'), function(
                input
            ) {
                if (input.checkValidity && !input.checkValidity()) {
                    plainInputsValid = false;
                    return;
                }
            });
            if (!plainInputsValid) {
                triggerBrowserValidation();
                return;
            }

            // Show a loading screen...
                loader(that, true)

            // Disable all inputs.
            disableInputs();

            // Gather additional customer data we may have collected in our form.
            // let additionalData = {};

            errorMessage.innerText = ''

                if(that.selectedPlan === that.activePlan || that.$route.query.module === 'payment'){
                    stripe.createPaymentMethod({type: 'card', card: elements[0]}).then(function(result) {
                        // Stop loading!
                        loader(that, false)
                        if (result.error) {
                            // Otherwise, un-disable inputs.
                            enableInputs();
                            // Inform the user if there was an error
                            errorMessage.innerText = window.i18next.t(result.error.message);
                        }else{
                            loader(that, true)
                            updatePaymentMethod({payment_method: result.paymentMethod.id}).then((response)=>{
                                loader(that, false)
                                message(that, constants.messageType.SUCCESS, window.i18next.t(response.message))
                                that.$router.push({name: pageRoutes.subscription})
                            }).catch((error)=>{
                                loader(that, false)
                                message(that, constants.messageType.ERROR, errorHandler(error, logout.bind(that, that)))
                            })
                        }
                })
                }else{
                    // Use Stripe.js to create a createPaymentMethod. We only need to pass in one Element
                    // from the Element group in order to create a token.
                    //for supporting SCA we have to use createPaymentMethod
                    stripe.createPaymentMethod({type: 'card', card: elements[0]}).then(function(result) {
                        // Stop loading!
                        loader(that, false)
                        if (result.error) {
                            // Otherwise, un-disable inputs.
                            enableInputs();
                            // Inform the user if there was an error
                            errorMessage.innerText = window.i18next.t(result.error.message);
                        } else {
                            // Send the paymentMethod Id to your server
                            loader(that, true)
                            fetchStripeCustomerId().then(()=>{
                                updatePaymentMethod({payment_method: result.paymentMethod.id}).then(()=>{
                                    subscribePlan({plan_id: that.selectedPlan}).then((res)=>{
                                        loader(that, false)
                                        if (res.requiresAction) {
                                          stripe.confirmCardPayment(res.clientSecret).then(function(data) {
                                            if (data.error) {
                                              console.log("Your card was not authenticated, please try again");
                                              message(that, constants.messageType.ERROR, errorHandler(data.error, logout.bind(that, that)))
                                            } else if(data.paymentIntent.status === 'succeeded'){
                                               // api call to log payment successed in database
                                               updateUserPlan({plan_id: that.selectedPlan}).then(function(userPlanResult) {
                                                   message(that, constants.messageType.SUCCESS, (userPlanResult.message))
                                                   that.$router.push({name: pageRoutes.subscription})
                                               });
                                            }
                                          })
                                        } else {
                                          message(that, constants.messageType.SUCCESS, (res.message))
                                          that.$router.push({name: pageRoutes.subscription})
                                        }
                                    }).catch((err)=>{
                                        loader(that, false)
                                        message(that, constants.messageType.ERROR, errorHandler(err, logout.bind(that, that)))
                                    })
                                }).catch((err)=>{
                                    loader(that, false)
                                    message(that, constants.messageType.ERROR, errorHandler(err, logout.bind(that, that)))
                                })
                            }).catch((error)=>{
                                loader(that, false)
                                message(that, constants.messageType.ERROR, errorHandler(error, logout.bind(that, that)))
                            })
                        }
                    });
                }
            });
    },
        /*
        * getSubscriptionsPlan() fetches all the available plans to subscribe
        * */
        getSubscriptionsPlan(){
            loader(this, true)
            getAllPlans().then((response)=>{
                this.plans = response.plans
                loader(this, false)
            }).catch((error)=>{
                loader(this, false)
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            })
        },
        /*
         * getUserActiveSubscription() fetches the active plan of the user.
         * */
        getUserActiveSubscription(){
            getActiveSubscription().then((response)=>{
                this.$store.dispatch('setExpiredSubscription', response.error)
                this.selectedPlan = response.plans &&
                    response.plans.length > 0 &&
                    response.plans[0].plan &&
                    response.plans[0].plan.id ? response.plans[0].plan.id : ''

                this.activePlan = response.plans &&
                response.plans.length > 0 &&
                response.plans[0].plan &&
                response.plans[0].plan.id ? response.plans[0].plan.id : ''

                if(this.$route.query.module === 'subscription'){
                    this.showSubscription = true
                }
            }).catch((error)=>{
                message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
            })
        },
        /*
        * to disable the submit button
        * if plan is not selected.
        * */
        isButtonDisabled(){
            if(this.$route.query.module === 'payment'){
                return false
            }else{
                return this.selectedPlan === ''
            }
        },
        /*
        * selects a plan
        * */
        selectPlan(plan){
            this.selectedPlan = plan.id
        },
        /*
        * allows user to change subscription only
        * */
        changeSubscription(){
            let self = this
            loader(this, true)
            subscribePlan({plan_id: this.selectedPlan }).then((response)=>{
                loader(self, false)
                if (response.requiresAction) {
                    loader(self, true)
                    this.globalStripe.confirmCardPayment(response.clientSecret).then(function(data) {
                      if (data.error) {
                        loader(self, false)
                        console.log("Your card was not authenticated, please try again");
                        message(this, constants.messageType.ERROR, ("Your card was not authenticated, Please try again"))
                      } else if(data.paymentIntent.status === 'succeeded'){
                         loader(self, false)
                         // api call to log payment successed in database
                         updateUserPlan({plan_id: self.selectedPlan}).then(function(userPlanResult) {
                             message(self, constants.messageType.SUCCESS, (userPlanResult.message))
                             self.$router.push({name: pageRoutes.subscription})
                         });
                      }
                    })
                  } else {
                    message(self, constants.messageType.SUCCESS, (response.message))
                    self.$router.push({name: pageRoutes.subscription})
                  }      
            }).catch((error)=>{
                loader(self, false)
                message(self, constants.messageType.ERROR, errorHandler(error, logout.bind(self, self)))
            })
        },
        /*
         * getPaymentDetails() calls the api to get the
         * user payment details
         * */
        getPaymentDetails(){
            fetchStripeCustomerId().then((response)=>{
                if(response.stripe_customer && 
                    response.stripe_customer.invoice_settings &&
                    response.stripe_customer.invoice_settings.default_payment_method) {
                        this.card = {}
                        this.showPayment = false
                    }
                if (response.card_details && response.card_details.card) {
                    this.card = response.card_details.card
                    this.showPayment = false
                } else {
                    this.card = {}
                    this.showPayment = true
                }
            })
        }
    }
}
